<template>
  <div>
    <taxexempgroup-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import TaxExempGroupForm from "../../../components/payroll/taxablerebategroupsetup/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "taxexempgroup-form": TaxExempGroupForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setuptaxablerebategroup.newtaxablerebategroup'),
      pageTitleValue: "",
      formData: {
        rebategroupcode: null,
        rebategroupdesc: null,
        startdate: null,
        enddate: null,
        rebatelimitamount: null,
        currencyid: null,
        frequency: null,
        controlid: null,
        remark: null,
        stamp: null,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    //insert new record
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/taxablerebategroup/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "taxablerebategroupsetuplist" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "taxablerebategroupsetuplist" });
    },
  },
};
</script>